export default __webpack_public_path__ + "static/media/gmail.73cb54a8.png";